// extracted by mini-css-extract-plugin
export default {"photos":"ProdutosNovo_photos__BDlVK","photos_placeholder":"ProdutosNovo_photos_placeholder__rZCvM"};